import React, { useContext, useEffect } from "react";

/// React router dom
import { Routes, Route, Outlet, Navigate, useNavigate } from "react-router-dom";
import RoleRoute from "./layouts/nav/RoleRoute";
import { getCurrentRoleContext, getMenuList } from "./layouts/nav/Menu";
import { getDefaultHomePath } from "./layouts/nav/routeAccess";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
import "../css/monitor-kiosk.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";

/// Pages
//import Registration from "./pages/Registration";
//import Login from "./pages/Login";
//import ForgotPassword from "./pages/ForgotPassword";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import HousekeepingRequests from "./pages/HousekeepingRequests";
import AcceptedTask from "./pages/AcceptedTask";
import PropertyList from "./pages/Properties/PropertyList";
import PropertyCreate from "./pages/Properties/PropertyCreate";
import PropertyEdit from "./pages/Properties/PropertyEdit";
import OwnershipRecords from "./pages/OwnershipRecords/OwnershipList";
import OwnershipCreate from "./pages/OwnershipRecords/OwnershipCreate";
import OwnershipEdit from "./pages/OwnershipRecords/OwnershipEdit";
import ManageHKT from "./pages/ManageHousekeeping/ManageHKT";
import HouseKeepingStats from "./pages/HousekeepingStats/HouseKeepingStats";
import CreateMapping from "./pages/ManageHousekeeping/CreateMapping";
import EditMapping from "./pages/ManageHousekeeping/EditMapping";
import CreateRoomItem from "./pages/ManageHousekeeping/CreateRoomItemMapper";
import EditRoomItemMapper from "./pages/ManageHousekeeping/EditRoomItemMapper";
import CreateRoomItemTask from "./pages/ManageHousekeeping/CreateRoomItem";
import EditRoomItem from "./pages/ManageHousekeeping/EditRoomItem";
import CreateTask from "./pages/ManageHousekeeping/CreateTask";
import EditTask from "./pages/ManageHousekeeping/EditTask";
import PrepModeIndex from "./pages/Mode/PrepModeIndex";
import ForecastList from "./pages/Forecast/ForecastList";
import UpdateForecast from './pages/Forecast/UpdateForecast'
import DashboardIndex from './pages/Dashboard/index'
import ReLogin from "./pages/Dashboard/ReLogin";
import ResourceStatsIndex from "./pages/ResourceStats/ResourceStatsIndex";
import DemoGraphIndex from "./components/Graph";
import ResourceDemandIndex from "./pages/ResourceDemand/ResourceDemandIndex";
import MultiPropertyMonitor from "./pages/Monitor/MultiPropertyMonitor";
import TaskProcess from "./components/Mode/taskProcess/TaskProcess";
import RoomStatusHistory from "./pages/Monitor/RoomStatusHistory";
import FunctionTimeSegmentsReport from "./pages/Reports/FunctionTimeSegmentsReport";
import ReservationReport from "./pages/Reports/ReservationReport";
import PerformanceManagementReport from "./pages/Reports/PerformanceManagementReport";
import PerformanceVariancesReport from "./pages/Reports/PerformanceVariancesReport";
import TimecardReport from "./pages/Reports/TimecardReport";
import ReservationProfile from "./pages/ReservationProfile/ReservationProfile";

// Component to handle root route redirect for roomops users
const RootRouteHandler = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const { roleName } = getCurrentRoleContext();
    navigate(getDefaultHomePath(getMenuList(), roleName), { replace: true });
  }, [navigate]);
  
  return null;
};

const Markup = () => {

  const allroutes = [
    /// Dashboard
    { url: "", component: <RootRouteHandler /> },
    { url: "dashboard", component: <DashboardIndex /> },
    { url: "tasks-process/:id", component: <TaskProcess /> },
    { url: "/change-property", component: <ReLogin /> },
    { url: "/monitor", component: <Navigate to="/multi-property-monitor" replace /> },
    { url: "/multi-property-monitor", component: <MultiPropertyMonitor /> },
    { url: "/room-status-history", component: <RoomStatusHistory /> },
    { url: "/function-time-segments-report", component: <FunctionTimeSegmentsReport /> },
    { url: "/reservation-report", component: <ReservationReport /> },
    { url: "/reservation-profile/:confirmation_number", component: <ReservationProfile /> },
    { url: "/performance-management-report", component: <PerformanceManagementReport /> },
    { url: "/performance-variances-report", component: <PerformanceVariancesReport /> },
    { url: "/timecard-report", component: <TimecardReport /> },
    // custom
    { url: "housekeeping-request", component: <HousekeepingRequests /> },
    { url: "accepted-task/:id", component: <AcceptedTask /> },
    { url: "properties-list", component: <PropertyList /> },
    { url: "properties-create", component: <PropertyCreate /> },
    { url: "properties-edit/:id", component: <PropertyEdit /> },
    { url: "ownership-list", component: <OwnershipRecords /> },
    { url: "ownership-create", component: <OwnershipCreate /> },
    { url: "ownership-edit/:id", component: <OwnershipEdit /> },
    { url: "manage-requests", component: <ManageHKT /> },
    { url: "housekeeping-stats", component: <HouseKeepingStats /> },
    { url: "create-mapping", component: <CreateMapping /> },
    { url: "mapping-edit/:id", component: <EditMapping /> },
    { url: "room-item-mapper/create", component: <CreateRoomItem /> },
    { url: "room-item-mapper/edit/:id", component: <EditRoomItemMapper /> },
    { url: "room-item/create", component: <CreateRoomItemTask /> },
    { url: "room-item/edit/:id", component: <EditRoomItem /> },
    { url: "room-task/create", component: <CreateTask /> },
    { url: "room-task/edit/:id", component: <EditTask /> },
    { url: "forecast/update", component: <UpdateForecast /> },
    { url: "forecast/list", component: <ForecastList /> },
    { url: "resource-stats", component: <ResourceStatsIndex /> },
    { url: "shift-details", component: <DemoGraphIndex /> },
    { url: "resource-model", component: <ResourceDemandIndex /> },

    ///// pages
    //{ url: "page-register", component: Registration },
    //{ url: "page-lock-screen", component: <LockScreen /> },
    ////{ url: "page-login", component: Login },
    //{ url: "page-forgot-password", component: <ForgotPassword /> },
    //{ url: "page-error-400", component: <Error400 /> },
    //{ url: "page-error-403", component: <Error403 /> },
    //{ url: "page-error-404", component: <Error404 /> },
    //{ url: "page-error-500", component: <Error500 /> },
    //{ url: "page-error-503", component: <Error503 /> },
  ];
  //let path = window.location.pathname;
  //path = path.split("/");
  //path = path[path.length - 1];

  //let pagePath = path.split("-").includes("page");
  //const { menuToggle } = useContext(ThemeContext);

  return (
    <>
      <Routes>
        <Route path='page-lock-screen' element={<LockScreen />} />
        <Route path='page-error-400' element={<Error400 />} />
        <Route path='callback' element={<Error400 />} />
        <Route path='page-error-403' element={<Error403 />} />
        <Route path='page-error-404' element={<Error404 />} />
        <Route path='page-error-500' element={<Error500 />} />
        <Route path='page-error-503' element={<Error503 />} />
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={<RoleRoute>{data.component}</RoleRoute>}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />

    </>
  );
};


function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  )

};

export default Markup;
